import React from "react";
import syllabusStyle from "./Syllabus.module.scss";
export default function Syllabus() {
  return (
    <div>
      <h1>Syllabus</h1>
    </div>
  );
}
